import { AttachFileOutlined } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { blue } from "@mui/material/colors";
import React from "react";

const FileChip = ({ file, label, onPreview, color = blue, sx }) => (
  <Chip
    icon={<AttachFileOutlined sx={{ fontSize: "14px !important" }} />}
    label={
      label ||
      file?.file_display_name ||
      file?.fileName ||
      file?.file_name_as_loaded ||
      "File"
    }
    size="small"
    color="error"
    onClick={(e) => {
      e.stopPropagation();
      onPreview?.(file);
    }}
    sx={{
      height: 22,
      fontSize: 11,
      fontWeight: 500,
      bgcolor: color[50],
      color: color[700],
      borderRadius: "4px",
      cursor: "pointer",
      "& .MuiChip-icon": { color: color[400] },
      "&:hover": { bgcolor: color[100] },
      ...sx,
    }}
  />
);
export default FileChip;
